import { createSlice } from "@reduxjs/toolkit";

interface MarketAnalysisReportInitialStateModel {
  filter:any;
}
const MarketAnalysisReportInitialState: MarketAnalysisReportInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:-1,
  

  }
};

const marketAnalysisReportSlice = createSlice({
  name: "MarketAnalysisReportSlice ",
  initialState: MarketAnalysisReportInitialState,
  reducers: {
    handleSetMarketAnalysisReportFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetMarketAnalysisReportFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:-1,
        
      };
    },
  },
});

export const {
  handleSetMarketAnalysisReportFilter,
  handleResetMarketAnalysisReportFitler,
} = marketAnalysisReportSlice.actions;
export default marketAnalysisReportSlice;
